import { stdObject } from "../../data/types/stdObject";
import { getIssueInputType, getIssueKey } from "../../utils/getIssueKey";
import WriteInput from "./WriteInput";
import NOPIC from "../../assets/nopic.svg";
import { colors } from "../../data/colors";
import { useDocContext } from "../../context/MainContext";
import { useSelector } from "react-redux";
import { RootState } from "../../store/store";

export default function IssuesTypeInput({
  data,
  mainWidth,
  initOwner,
  minSizeDoc,
}: stdObject) {
  const { docActive } = useDocContext();
  const user: any = useSelector((state: RootState) => state.data.user);
  const checkIsHidden = () => {
    return (
      (data.SEC2SDD &&
        (user.TEC === 1 || (user.TEC === 0 && user.CODUSU === initOwner))) ||
      (data.SECSDD &&
        (user.TEC === 0 || (user.TEC === 1 && user.CODUSU !== initOwner)))
    );
  };
  return [0, 1, 2, 3, 4, 6, 7, 8].includes(data.TIPSDD) ? (
    <WriteInput
      data={{
        label: data.NOMSDD,
        code: data.CODSDD,
        type: checkIsHidden() ? "hidden" : getIssueInputType(data.TIPSDD),
        active: docActive.issues,
        value:
          data.TIPSDD === 3
            ? data[getIssueKey(data.TIPSDD)].replaceAll("<br>", "\n")
            : data[getIssueKey(data.TIPSDD)],
        suffix: data.SUFSDD,
        onChange: data.onChange,
        options:
          data.TIPSDD === 4
            ? data.TXTSDD.split(",").map((e: string) => {
                return { label: e, value: e };
              })
            : [],
        inputStyle: {
          paddingLeft: 5,
          paddingRight: 5,
          width:
            (minSizeDoc || mainWidth) && ![4, 6, 7].includes(data.TIPSDD)
              ? "100%"
              : [6].includes(data.TIPSDD)
                ? 100
                : [1, 0, 4, 7, 8].includes(data.TIPSDD)
                  ? "auto"
                  : "25%",
        },
        innerStyle: { width: [1].includes(data.TIPSDD) ? 100 : "100%" },
      }}
    />
  ) : data.TIPSDD === 5 ? (
    <div
      className="listImage"
      style={{ width: 250, height: 175, margin: 3 }}
      onClick={docActive.issues ? data.onClick : null}
    >
      <img
        src={data.DRAWING ?? data.ORIGINAL}
        onError={(v: any) => (v.target.src = NOPIC)}
        loading="lazy"
        alt={data.CODSDD}
      />
    </div>
  ) : (
    <div
      style={{
        backgroundColor: data.TIPSDD === 9 ? colors.white : colors.grey,
        fontSize: 14,
        fontWeight: "bolder",
        width: "100%",
        padding: data.TIPSDD === 9 ? 0 : 5,
      }}
    >
      {data.TIPSDD === 9 ? "" : data.NOMSDD}
    </div>
  );
}
